import React from "react"

import { LayersRounded as LayersRoundedIcon } from "@material-ui/icons"
import { FolderRounded as FolderRoundedIcon } from "@material-ui/icons"
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  makeStyles,
  Theme,
} from "@material-ui/core"
import { GroupDataShape } from "./usePortalGroups"
import { LoadingList } from "../common/LoadingList"

const listIcons: Record<string, any> = {
  "Feature Service": LayersRoundedIcon,
}

interface GroupsAndLayersListProps {
  groups: GroupDataShape[] | undefined
  onClick: (layer: __esri.FeatureLayer) => void
}

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  root: {
    maxWidth: theme.spacing(75),
  },
  groupTitle: {
    // fontWeight:
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  listItemText: {
    "& .MuiListItemText-primary,.MuiListItemText-secondary": {
      width: "100%",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
  },
}))

export const GroupsAndLayersList: React.FC<GroupsAndLayersListProps> = ({
  groups,
  onClick,
}) => {
  /** Get scoped CSS classes */
  const classes = useStyles()

  return groups ? (
    <List className={classes.root}>
      {groups &&
        groups.map(({ group, featureLayers }) => (
          <React.Fragment key={group.id}>
            <ListItem>
              <ListItemIcon>
                <FolderRoundedIcon />
              </ListItemIcon>
              <ListItemText primary={group.title} />
            </ListItem>
            <Collapse in={true}>
              <List>
                {featureLayers.map(feature => {
                  const Icon = listIcons[feature.type] || null
                  return (
                    <ListItem
                      button
                      key={feature.id}
                      onClick={() => onClick(feature)}
                      className={classes.nested}
                    >
                      {Icon && (
                        <ListItemIcon>
                          <Icon />
                        </ListItemIcon>
                      )}
                      <ListItemText
                        primary={feature.title}
                        // @ts-ignore
                        secondary={feature.snippet}
                        className={classes.listItemText}
                      />
                    </ListItem>
                  )
                })}
              </List>
            </Collapse>
          </React.Fragment>
        ))}
    </List>
  ) : (
    <LoadingList />
  )
}
